import { createContext } from "react";

const AllTasksContext = createContext([]);

export default AllTasksContext;
